import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

document.addEventListener('DOMContentLoaded', () => {
  const burger = document.getElementById('burger')
  const close = document.getElementById('close')
  const menu = document.querySelector('.header__nav')
  const navLinks = document.querySelectorAll('.header__nav-link')

  burger.addEventListener('click', () => {
    menu.classList.add('active')
  })

  close.addEventListener('click', () => {
    menu.classList.remove('active')
  })

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      menu.classList.remove('active')
    })
  })
})
